import React from "react";
import Content from "./Content.js";
import Nav from "./components/Nav";

function App() {
  return (
    <div className="App">
      <Nav />
      <Content />
    </div>
  );
}

try {
  App();
} catch (error) {
  console.error("Error!");
  throw error;
} finally {
  console.log("Finally!");
}

export default App;
